import React, { FunctionComponent } from 'react';

import Flex, { FlexProps } from '@gojob/ui-bits/Flex';
import Icon, { IconProps } from '@gojob/ui-bits/Icon';
import Subtitles from '@gojob/ui-bits/Icons/Subtitles';
import useTheme from '@gojob/ui-bits/styles/useTheme';
import Typography, { TypographyProps } from '@gojob/ui-bits/Typography';

import useTranslation from 'src/translations/useTranslation';

export interface NoResultsProps extends FlexProps<'div'> {
  IconProps?: Omit<IconProps, 'ref'>;
  TypographyProps?: TypographyProps;
}

const useStyles = () => {
  const { spacing } = useTheme();
  return {
    icon: {
      margin: spacing(2, 0),
    },
    typography: {
      textAlign: 'center',
      whiteSpace: 'pre-wrap',
    },
  } as const;
};

const NoResults: FunctionComponent<NoResultsProps> = (props) => {
  const { IconProps, TypographyProps, ...other } = props;

  const classes = useStyles();
  const t = useTranslation();

  return (
    <Flex flexDirection="column" alignItems="center" {...other}>
      <Icon css={classes.icon} color="icon" size={16} as={Subtitles} {...IconProps} />
      <Typography css={classes.typography} variant="headline3" color="icon" {...TypographyProps}>
        {t('nothing_found')}
      </Typography>
    </Flex>
  );
};

export default NoResults;
